import React, { Component } from "react";
import "./AuthLinkedin.scss";
import { connect } from "react-redux";
import { linkedinLogin } from "../../../actions/authAction";
import { Redirect } from "react-router-dom";
import Dimmer from "semantic-ui-react/dist/es/modules/Dimmer";
import Loader from "semantic-ui-react/dist/es/elements/Loader";
import { ReactComponent as AuthenticateIcon } from "../../../assets/svg/authentication-icon.svg";

class AuthLinkedin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            authFailed: false,
            redirectToSocialToken: false,
        };
    }

    componentDidUpdate() {
        document.title = "Radarr | Sign In";
    }

    componentDidMount() {
        if (window.location.href.indexOf("?code=") > 0) {
            const url = window.location;
            const code = new URLSearchParams(url.search).get("code");
            const redirectURl = window.location.href.split("?")[0];
            const param = {};
            param["auth_code"] = code;
            param["platform"] = "linkedin";
            param["redirect_url"] = redirectURl;
            this.props.linkedinLogin(param);
        }

        if (window.location.href.indexOf("?error") > 0) {
            this.setState({ authFailed: !this.state.authFailed });
        }
        // if (window.location.href.indexOf("socialToken") > 0) {
        //     this.setState({ redirectToSocialToken: true });
        // }
    }
    render() {
        return (
            <div className="authLinkedin">
                <h3 className="header__text">Please wait for some time while we are authenticating</h3>
                <div className="authenticate__icon">
                    <AuthenticateIcon />
                </div>
                {this.props.linkedinLoginLoading && (
                    <div className="list-loading">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Authenticating</Loader>
                        </Dimmer>
                    </div>
                )}
                {this.props.linkedinLogedIn && <Redirect to="/home" />}
                {/* {this.props.linkedinLogedIn && (this.state.redirectToSocialToken ? <Redirect to="/social-tokens" /> : <Redirect to="/home" />)}

                {(this.props.linkedinLoginFailed || this.state.authFailed) &&
                    (this.state.redirectToSocialToken ? <Redirect to="/social-tokens" /> : <Redirect to="/signin" />)} */}
                {(this.props.linkedinLoginFailed || this.state.authFailed) && <Redirect to="/signin" />}

                {/* {this.props.linkedinLogedIn &&
                    window.history.replaceState(null, "", window.location.origin+"/home")
                } */}
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        linkedinLogedIn: state.authReducer.linkedinLogedIn,
        linkedinLoginLoading: state.authReducer.linkedinLoginLoading,
        linkedinLoginFailed: state.authReducer.linkedinLoginFailed,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        linkedinLogin: (params) => dispatch(linkedinLogin(params)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(AuthLinkedin);
